"use client";

import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { Step } from "./ProcessSlide";

export function ProcessNavigation({
  steps,
  activeIndex,
  onStepClick,
}: {
  steps: readonly Step[];
  activeIndex: number;
  onStepClick: (index: number) => void;
}) {
  return (
    <div className="w-full px-6 sm:px-12 pt-6 sm:pt-8 pb-4 flex justify-center">
      <div className="max-w-5xl w-full relative">
        {/* Progress Track — h-1 (4px) matches node border-4 */}
        <div className="absolute top-8 left-8 right-8 h-1 bg-(--border-subtle) z-0 -translate-y-1/2">
          <motion.div
            className="absolute top-0 left-0 h-full bg-(--brand-primary)"
            initial={{ width: "0%" }}
            animate={{ width: `${(activeIndex / (steps.length - 1)) * 100}%` }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          />
        </div>

        {/* Indicators */}
        <div className="flex justify-between items-center relative z-10">
          {steps.map((step, i) => {
            const isActive = i === activeIndex;
            const isPast = i < activeIndex;
            const Icon = step.icon;

            return (
              <button
                key={step.id}
                type="button"
                onClick={() => onStepClick(i)}
                aria-label={`Go to step ${i + 1}`}
                className="flex flex-col items-center outline-none relative group"
              >
                {/* Node */}
                <div className="relative z-20 transition-transform duration-300 group-hover:scale-110">
                  <div
                    className={cn(
                      "w-16 h-16 rounded-full bg-(--bg-primary) border-4 flex items-center justify-center relative z-20 transition-colors duration-300 shadow-lg",
                      "focus-visible:ring-2 focus-visible:ring-(--brand-primary) focus-visible:ring-offset-2 ring-offset-(--bg-primary)",
                      isActive || isPast
                        ? "border-(--brand-primary) text-(--brand-primary)"
                        : "border-(--border-subtle)",
                    )}
                  >
                    <div className="absolute inset-1 rounded-full bg-(--bg-card)" />
                    <Icon className="w-6 h-6 relative z-10 transition-colors duration-300" />
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
